import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { ButtonWrapper } from "styles/ModalCommonStyled";
import BigButton from "components/atoms/buttons/BigButton";
import * as s from "./CotermWorkStyled";
import {
  SelectedRowAccountInfo,
  SubscriptionDetailSummaryResult,
} from "api/interfaces/subscription.interface";
import { Radio, RadioChangeEvent } from "antd";
import { useLayoutEffect, useMemo, useState } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { LuCalculator } from "react-icons/lu";
import CalculatedResultCard from "./card/CalculatedResultCard";
import CurrentCard from "./card/CurrentCard";
import { useAddChannelCalculator } from "./useAddChannelCalculator";
import { usePurchaseCalculator } from "./usePurchaseCalculator";
import { differenceInDays, getUtcDate } from "utils/timeUtil";

export enum CALCULATE_TYPE {
  CHANNEL = "channel",
  PURCHASE = "purchase",
}
export type CotermCalculateType = CALCULATE_TYPE;

type Props = {
  onModal: () => void;
  selectedRowAccount: SelectedRowAccountInfo;
  data: SubscriptionDetailSummaryResult;
};

export default function SubscriptonCotermWorkModal(props: Props): JSX.Element {
  const { registeredChannel, expiration, totalUnit } = props.data;

  const isAddChannelByExpireDate = useMemo(() => {
    const today = getUtcDate(new Date());

    return (
      expiration &&
      differenceInDays(getUtcDate(expiration).toUTCString(), today) >= 0
    );
  }, [expiration]);

  const [tabType, setTabType] = useState<CotermCalculateType>(
    isAddChannelByExpireDate ? CALCULATE_TYPE.CHANNEL : CALCULATE_TYPE.PURCHASE
  );

  // IMPORTANT: call hooks once here and share state between cards via props
  const addChannelCalc = useAddChannelCalculator({
    registeredChannel,
    expiration:
      expiration?.length === 10 ? `${expiration}T00:00:00.000Z` : expiration,
    totalUnit,
  });
  const purchaseCalc = usePurchaseCalculator({
    registeredChannel,
    expiration:
      expiration && expiration.length === 10
        ? `${expiration}T00:00:00.000Z`
        : expiration,
  });

  const handleTabs = (e: RadioChangeEvent) => {
    if (!isAddChannelByExpireDate) {
      return;
    }
    setTabType(e.target.value);
  };

  useLayoutEffect(() => {
    const el = document.getElementById("Co-Termination Date Calculator_popup");
    if (!el) return;
    el.style.overflow = "visible";
  }, []);

  return (
    <BigPopupTemplate
      title="Co-Termination Date Calculator"
      onModal={props.onModal}
    >
      <s.Inner>
        {/* <s.TopInfo>
          <MdOutlineTipsAndUpdates size={30} />
          <p>
            MyDW aggregates the duration of all licenses and distributes them
            evenly across your active cameras.
          </p>
        </s.TopInfo> */}
        {}

        <Radio.Group onChange={handleTabs} value={tabType}>
          {isAddChannelByExpireDate && (
            <Radio.Button value={CALCULATE_TYPE.CHANNEL}>
              <div className="coterm-tab">
                <LuCalculator size={18} />
                Add / Reduce Channels
              </div>
            </Radio.Button>
          )}

          <Radio.Button value={CALCULATE_TYPE.PURCHASE}>
            <div className="coterm-tab">
              <AiOutlineShoppingCart size={18} />
              Purchase Subscription
            </div>
          </Radio.Button>
        </Radio.Group>
        <ul className="card-wrapper">
          <CurrentCard
            tabType={tabType}
            addChannelCalc={addChannelCalc}
            purchaseCalc={purchaseCalc}
            expiration={expiration}
          />
          <CalculatedResultCard
            tabType={tabType}
            addChannelCalc={addChannelCalc}
            purchaseCalc={purchaseCalc}
          />
        </ul>
      </s.Inner>
      <ButtonWrapper>
        <BigButton label="OK" onClickBtn={props.onModal} />
      </ButtonWrapper>
    </BigPopupTemplate>
  );
}
